var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "mx-auto" }, [
    _c(
      "div",
      {
        staticClass: "wrapper bg-white rounded shadow w-full",
        attrs: { id: "mainSchContainer" },
      },
      [
        _c("top-item-picker", {
          attrs: {
            currentYear: _vm.currentYear,
            currentWeekNumber: _vm.currentWeekNumber,
            weekStart: _vm.getWeekStartDay,
            weekEnd: _vm.getWeekEndDay,
            currentMonth: _vm.getMonthOfWeekStartDay,
            nextMonth: _vm.getMonthOWeekEndDay,
            quater: _vm.getQuarter,
            defaultSelectedOption: _vm.selectedOption,
            isCollapsed: _vm.isCollapsed,
          },
          on: {
            today: _vm.today,
            next: _vm.next,
            prev: _vm.prev,
            optionChange: _vm.optionChange,
            collapseAll: _vm.collapseAll,
          },
        }),
        _c(
          "div",
          { staticStyle: { "overflow-x": "hidden", "overflow-y": "auto" } },
          [
            _c(
              "div",
              {
                staticClass: "flex flex-row border-b",
                staticStyle: { overflow: "hidden" },
              },
              [
                _c(
                  "div",
                  { staticClass: "flex flex-row" },
                  [
                    _c("item-left-header", { attrs: { name: _vm.filterBy } }),
                    _c("circle-progress-header", {
                      attrs: { name: "Progress" },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "relative flex flex-row",
                    staticStyle: { overflow: "auto", "margin-bottom": "0px" },
                  },
                  [
                    _vm.isDays
                      ? _vm._l(_vm.getWeekDates, function (item, index) {
                          return _c(
                            "item-right-header",
                            {
                              key: "day" + index,
                              attrs: { width: _vm.columnSpan },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex justify-center items-center content-center",
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "text-center pt-2" },
                                    [_vm._v(_vm._s(item) + " ")]
                                  ),
                                ]
                              ),
                            ]
                          )
                        })
                      : _vm._e(),
                    _vm.isMonths
                      ? _vm._l(_vm.getQuarterMonths, function (item, index) {
                          return _c(
                            "item-right-header",
                            {
                              key: "mongth" + index,
                              attrs: { width: _vm.columnSpan },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex justify-center items-center content-center",
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "days-week text-center pt-2 w-full",
                                    },
                                    [_vm._v(_vm._s(item))]
                                  ),
                                ]
                              ),
                            ]
                          )
                        })
                      : _vm._e(),
                    _vm.isWeeks
                      ? _vm._l(_vm.getWeeks, function (item, index) {
                          return _c(
                            "item-right-header",
                            {
                              key: "mongth" + index,
                              attrs: { width: _vm.columnSpan },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex justify-center items-center content-center",
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "days-week text-center pt-2 w-full",
                                      attrs: { y: "" },
                                    },
                                    [_vm._v("Week " + _vm._s(item))]
                                  ),
                                ]
                              ),
                            ]
                          )
                        })
                      : _vm._e(),
                  ],
                  2
                ),
              ]
            ),
          ]
        ),
        _vm.filterBy == "Manager"
          ? _c(
              "div",
              {
                staticStyle: {
                  height: "52vh",
                  "overflow-x": "hidden",
                  "overflow-y": "auto",
                },
              },
              _vm._l(_vm.managers, function (manager, index) {
                return _c("manager-collapse", {
                  key: manager.id,
                  attrs: {
                    weekDates: _vm.getWeekDates,
                    quarterMonths: _vm.getQuarterMonths,
                    weeks: _vm.getWeeks,
                    isDays: _vm.isDays,
                    isMonths: _vm.isMonths,
                    isWeeks: _vm.isWeeks,
                    columnSpan: _vm.columnSpan,
                    manager: manager,
                    filterBy: _vm.filterBy,
                    isCollapsed: _vm.isCollapsed,
                    getEarliestDate: _vm.getEarliestDate,
                    pickerCurrentDate: _vm.currentDate,
                    currentUser: _vm.currentUser,
                    companyId: _vm.companyId,
                    index: index,
                  },
                })
              }),
              1
            )
          : _vm._e(),
        _vm.filterBy == "Contractor"
          ? _c(
              "div",
              {
                staticStyle: {
                  height: "52vh",
                  "overflow-x": "hidden",
                  "overflow-y": "auto",
                },
              },
              _vm._l(_vm.contractors, function (contractor, index) {
                return _c("contractor-collapse", {
                  key: contractor.id,
                  attrs: {
                    weekDates: _vm.getWeekDates,
                    quarterMonths: _vm.getQuarterMonths,
                    weeks: _vm.getWeeks,
                    isDays: _vm.isDays,
                    isMonths: _vm.isMonths,
                    isWeeks: _vm.isWeeks,
                    columnSpan: _vm.columnSpan,
                    isCollapsed: _vm.isCollapsed,
                    contractor: contractor,
                    filterBy: _vm.filterBy,
                    getEarliestDate: _vm.getEarliestDate,
                    pickerCurrentDate: _vm.currentDate,
                    currentUser: _vm.currentUser,
                    companyId: _vm.companyId,
                    index: index,
                  },
                })
              }),
              1
            )
          : _vm._e(),
        _vm.filterBy == "Project"
          ? _c(
              "div",
              {
                staticClass: "relative z-0",
                staticStyle: {
                  height: "52vh",
                  "overflow-x": "hidden",
                  "overflow-y": "auto",
                },
              },
              _vm._l(_vm.projects, function (project, index) {
                return _c("project-collapse", {
                  key: project.id,
                  attrs: {
                    weekDates: _vm.getWeekDates,
                    quarterMonths: _vm.getQuarterMonths,
                    weeks: _vm.getWeeks,
                    isDays: _vm.isDays,
                    isMonths: _vm.isMonths,
                    isWeeks: _vm.isWeeks,
                    columnSpan: _vm.columnSpan,
                    project: project,
                    filterBy: _vm.filterBy,
                    isCollapsed: _vm.isCollapsed,
                    getEarliestDate: _vm.getEarliestDate,
                    pickerCurrentDate: _vm.currentDate,
                    currentUser: _vm.currentUser,
                    companyId: _vm.companyId,
                    index: index,
                  },
                })
              }),
              1
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }